/* ===========================================================================
   PHP LABOR DAY POPUP  —  labor-day-popup.js

   Site-wide promo popup for the Labor Day sale:
   free Staging Limiter / Lope Idle tune with any Medusa.

   INSTALL
     1. Online Store > Themes > ... > Edit code > Assets > Add a new asset
        > Upload this file (labor-day-popup.js)
     2. Theme customizer > Footer group > Add section > Custom Liquid,
        containing:

          <script src="{{ 'labor-day-popup.js' | asset_url }}" defer></script>

        The Footer group renders on every page, so one block covers the site.

   IT TURNS ITSELF OFF.
     ENDS_AT below is the end of the sale. After that the script returns
     immediately and renders nothing, so a forgotten block is harmless.
     Removing the section afterwards is still tidier.

   TO SWAP THE GRAPHIC
     Change IMAGE. Any Shopify CDN URL works. Appending &width=900 asks
     Shopify for a resized copy.

   TO ADD VINNY'S VIDEO
     Set VIDEO to a YouTube/Vimeo embed URL or a direct .mp4 and the media
     panel becomes a click-to-play video instead of the image. It never
     autoplays — autoplay in a popup gets blocked and annoys people.
       YouTube:  https://www.youtube.com/embed/VIDEO_ID
       Vimeo:    https://player.vimeo.com/video/VIDEO_ID
       File:     https://cdn.shopify.com/.../vinny.mp4
   =========================================================================== */
(function () {
  'use strict';

  /* ------------------------------------------------------------- settings */
  var ENDS_AT  = Date.parse('2026-09-09T03:59:59Z');   // Tue 8 Sep, 11:59pm EDT
  var STORAGE  = 'ph-labor-day-2026';
  var DELAY_MS = 4000;                                  // let the page land first
  var LINK     = '/products/medusa-interface-for-hydra-chip';
  var IMAGE    = 'https://cdn.shopify.com/s/files/1/0969/0284/0452/files/6.png?v=1784301870&width=900';
  var POSTER   = '';                                    // optional poster frame

  // The video URL comes from the Liquid block, not from this file, so it can be
  // pasted in from the theme customizer without re-uploading this asset:
  //   <div id="ph-labor-day" data-video="https://cdn.shopify.com/.../promo.mp4"></div>
  // Empty or missing -> the image version renders instead.
  var MOUNT = document.getElementById('ph-labor-day');
  var VIDEO = (MOUNT && MOUNT.getAttribute('data-video')) || '';

  /* --------------------------------------------------------------- guards */
  if (Date.now() > ENDS_AT) { return; }                 // sale is over
  if (window.__phLaborDay) { return; }                  // already ran
  window.__phLaborDay = 1;

  // Don't interrupt someone who is already on the Medusa page or checking out.
  var path = (window.location.pathname || '').toLowerCase();
  if (path.indexOf('/products/medusa-interface-for-hydra-chip') === 0) { return; }
  if (/^\/(cart|checkout|checkouts|orders|account|challenge|password)/.test(path)) { return; }

  // Shown once per visitor. Storage can throw in private mode — never block on it.
  function seen() {
    try { return window.localStorage.getItem(STORAGE) === '1'; } catch (e) { return false; }
  }
  function markSeen() {
    try { window.localStorage.setItem(STORAGE, '1'); } catch (e) {}
  }
  if (seen()) { return; }

  /* --------------------------------------------------------------- styles */
  var css = ''
    + '.phld{position:fixed;inset:0;z-index:2147483000;display:flex;align-items:center;'
    +   'justify-content:center;padding:20px;background:rgba(0,0,0,.72);opacity:0;'
    +   'transition:opacity .25s ease}'
    + '.phld.is-open{opacity:1}'
    + '.phld__card{position:relative;display:flex;width:100%;max-width:860px;'
    +   'max-height:calc(100vh - 40px);overflow:hidden;border-radius:12px;background:#111;'
    +   'color:#fff;box-shadow:0 24px 60px rgba(0,0,0,.55);transform:translateY(12px) scale(.98);'
    +   'transition:transform .25s ease;font-family:inherit}'
    + '.phld.is-open .phld__card{transform:none}'
    + '.phld__media{flex:0 0 44%;background:#000;position:relative;min-height:260px}'
    + '.phld__media img{width:100%;height:100%;object-fit:cover;'
    +   'object-position:center top;display:block}'
    + '.phld__media iframe{width:100%;height:100%;border:0;display:block}'
    /* Video card: stacked, and the 16:9 frame is never cropped — the video
       carries the offer as burned-in text, so cropping would eat the message. */
    + '.phld__card--video{flex-direction:column;max-width:620px}'
    /* max-height keeps the CTA above the fold on short laptop screens — without
       it the 16:9 frame pushes the button into the card's own scroll area. */
    + '.phld__card--video .phld__media{flex:none;min-height:0;width:100%;aspect-ratio:16/9;'
    +   'max-height:46vh}'
    + '.phld__card--video .phld__media video{width:100%;height:100%;object-fit:contain;'
    +   'display:block;background:#000}'
    + '.phld__card--video .phld__body{padding:22px 30px 26px;text-align:center}'
    + '.phld__card--video .phld__no{width:100%;text-align:center}'
    + '.phld__body{flex:1;padding:34px 34px 30px;overflow-y:auto}'
    + '.phld__eyebrow{font-size:12px;letter-spacing:.14em;text-transform:uppercase;'
    +   'font-weight:700;color:#4ade4a;margin:0 0 12px}'
    + '.phld__title{font-size:27px;line-height:1.18;font-weight:800;margin:0 0 14px;color:#fff}'
    + '.phld__title em{font-style:normal;color:#4ade4a}'
    + '.phld__sr{position:absolute;width:1px;height:1px;padding:0;margin:-1px;overflow:hidden;'
    +   'clip:rect(0 0 0 0);white-space:nowrap;border:0}'
    + '.phld__copy{font-size:15px;line-height:1.55;color:#c9c9c9;margin:0 0 10px}'
    + '.phld__ends{font-size:13px;line-height:1.5;color:#8f8f8f;margin:0 0 22px}'
    + '.phld__cta{display:inline-block;background:#d61f26;color:#fff;text-decoration:none;'
    +   'font-weight:700;font-size:16px;letter-spacing:.02em;padding:14px 28px;border-radius:6px;'
    +   'transition:background .15s ease}'
    + '.phld__cta:hover{background:#b8181f;color:#fff}'
    + '.phld__no{display:block;margin-top:16px;background:none;border:0;padding:0;'
    +   'color:#7d7d7d;font-size:13px;text-decoration:underline;cursor:pointer;font-family:inherit}'
    + '.phld__no:hover{color:#bbb}'
    + '.phld__x{position:absolute;top:10px;right:12px;z-index:2;width:36px;height:36px;'
    +   'border:0;border-radius:50%;background:rgba(0,0,0,.55);color:#fff;font-size:22px;'
    +   'line-height:1;cursor:pointer;transition:background .15s ease}'
    + '.phld__x:hover{background:rgba(0,0,0,.85)}'
    + '.phld__x:focus-visible,.phld__cta:focus-visible,.phld__no:focus-visible{'
    +   'outline:2px solid #4ade4a;outline-offset:2px}'
    + '@media (max-width:720px){'
    +   '.phld{padding:12px}'
    +   '.phld__card{flex-direction:column}'
    +   '.phld__media{flex:none;min-height:0;height:180px}'
    +   '.phld__card--video .phld__media{height:auto}'
    +   '.phld__body,.phld__card--video .phld__body{padding:20px 20px 24px}'
    +   '.phld__title{font-size:23px}'
    +   '.phld__cta{display:block;text-align:center}'
    + '}'
    + '@media (prefers-reduced-motion:reduce){'
    +   '.phld,.phld__card{transition:none}'
    + '}';

  var style = document.createElement('style');
  style.textContent = css;
  document.head.appendChild(style);

  /* --------------------------------------------------------------- markup */
  var hasVideo = !!VIDEO;

  function mediaHTML() {
    if (!hasVideo) {
      return '<img src="' + IMAGE + '" alt="Medusa Interface for Hydra Chip">';
    }
    if (/\.(mp4|webm|mov)(\?|$)/i.test(VIDEO)) {
      // Muted autoplay so it reads as a moving graphic. Muted autoplay is allowed
      // by browsers; unmuted is blocked, and would be obnoxious anyway. Controls
      // stay on so anyone who wants sound can turn it on.
      return '<video src="' + VIDEO + '"' + (POSTER ? ' poster="' + POSTER + '"' : '')
           + ' autoplay muted loop playsinline controls preload="auto"></video>';
    }
    return '<iframe src="' + VIDEO + '" title="Power Hungry Performance Labor Day sale" '
         + 'allow="accelerometer; autoplay; clipboard-write; encrypted-media; picture-in-picture" '
         + 'allowfullscreen loading="lazy"></iframe>';
  }

  // With the video, the offer is burned into the frames, so the text below it
  // explains the mechanics instead of repeating the headline.
  function bodyHTML(forceImage) {
    if (hasVideo && !forceImage) {
      return ''
        + '<h2 class="phld__sr" id="phld-title">Labor Day: free Lope Idle or Staging Limiter '
        +   'tune with any Medusa Interface</h2>'
        + '<p class="phld__copy">Tick the tune on the Medusa page and the $50 comes straight '
        +   'back off at checkout.</p>'
        + '<p class="phld__ends">Applied automatically. Runs through Tuesday, September 8.</p>'
        + '<a class="phld__cta" href="' + LINK + '">Shop the Medusa</a>'
        + '<button class="phld__no" type="button">No thanks</button>';
    }
    return ''
      + '<p class="phld__eyebrow">Labor Day Weekend</p>'
      + '<h2 class="phld__title" id="phld-title">Free tune with any <em>Medusa</em></h2>'
      + '<p class="phld__copy">Buy a Medusa Interface and add a Staging Limiter or Lope Idle '
      +   'tune right on the product page &mdash; the $50 comes straight back off at checkout.</p>'
      + '<p class="phld__ends">Applied automatically. Runs through Tuesday, September 8.</p>'
      + '<a class="phld__cta" href="' + LINK + '">Shop the Medusa</a>'
      + '<button class="phld__no" type="button">No thanks</button>';
  }

  var wrap = document.createElement('div');
  wrap.className = 'phld';
  wrap.setAttribute('role', 'dialog');
  wrap.setAttribute('aria-modal', 'true');
  wrap.setAttribute('aria-labelledby', 'phld-title');
  wrap.innerHTML = ''
    + '<div class="phld__card' + (hasVideo ? ' phld__card--video' : '') + '">'
    +   '<button class="phld__x" type="button" aria-label="Close">&times;</button>'
    +   '<div class="phld__media">' + mediaHTML() + '</div>'
    +   '<div class="phld__body">' + bodyHTML() + '</div>'
    + '</div>';

  /* ------------------------------------------------------------ behaviour */
  var lastFocus = null;
  var bodyOverflow = '';

  function close() {
    markSeen();
    wrap.classList.remove('is-open');
    document.body.style.overflow = bodyOverflow;
    document.removeEventListener('keydown', onKey, true);
    window.setTimeout(function () {
      if (wrap.parentNode) { wrap.parentNode.removeChild(wrap); }
      if (lastFocus && lastFocus.focus) { lastFocus.focus(); }
    }, 250);
  }

  // Buttons inside .phld__body are re-created if we fall back to the image,
  // so their listeners are attached here rather than once at open time.
  function rebind() {
    var no  = wrap.querySelector('.phld__no');
    var cta = wrap.querySelector('.phld__cta');
    if (no)  { no.addEventListener('click', close); }
    if (cta) { cta.addEventListener('click', markSeen); }
  }

  function onKey(ev) {
    if (ev.key === 'Escape' || ev.keyCode === 27) { close(); return; }
    if (ev.key !== 'Tab') { return; }
    // keep tabbing inside the dialog
    var f = wrap.querySelectorAll('button, a[href], video, iframe');
    if (!f.length) { return; }
    var first = f[0], last = f[f.length - 1];
    if (ev.shiftKey && document.activeElement === first) { ev.preventDefault(); last.focus(); }
    else if (!ev.shiftKey && document.activeElement === last) { ev.preventDefault(); first.focus(); }
  }

  function open() {
    if (Date.now() > ENDS_AT || seen()) { return; }   // re-check: tab may have sat open
    lastFocus = document.activeElement;
    document.body.appendChild(wrap);

    bodyOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';

    wrap.querySelector('.phld__x').addEventListener('click', close);
    rebind();
    wrap.addEventListener('click', function (ev) {
      if (ev.target === wrap) { close(); }            // backdrop only
    });
    document.addEventListener('keydown', onKey, true);

    // Some browsers ignore the autoplay attribute on a freshly inserted node.
    // Setting .muted as a property (not just the attribute) is what actually
    // satisfies the autoplay policy, then nudge it with play().
    var vid = wrap.querySelector('video');
    if (vid) {
      vid.muted = true;
      vid.defaultMuted = true;

      // A wrong or expired URL would otherwise leave a black rectangle where the
      // offer should be. Fall back to the product image instead.
      vid.addEventListener('error', function () {
        var card  = wrap.querySelector('.phld__card');
        var media = wrap.querySelector('.phld__media');
        if (!card || !media) { return; }
        card.className = 'phld__card';
        media.innerHTML = '<img src="' + IMAGE + '" alt="Medusa Interface for Hydra Chip">';
        var body = wrap.querySelector('.phld__body');
        if (body) { body.innerHTML = bodyHTML(true); rebind(); }
      }, true);

      var p = vid.play();
      if (p && p.catch) { p.catch(function () { /* blocked: controls are there */ }); }
    }

    // next frame, so the transition actually runs
    window.requestAnimationFrame(function () {
      wrap.classList.add('is-open');
      var x = wrap.querySelector('.phld__x');
      if (x) { x.focus(); }
    });
  }

  window.setTimeout(open, DELAY_MS);
})();
